import { useState } from "react";
import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";
import { useLogo } from "@/context/LogoContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import ImageUpload from "@/components/ImageUpload";
import { Image } from "lucide-react";

export default function LogoSettings() {
  const { logoPath, refresh } = useLogo();
  const [busy, setBusy] = useState(false);

  const save = async (path) => {
    setBusy(true);
    try {
      await api.put("/parametres/logo", { image_path: path });
      await refresh();
      toast.success(path ? "Logo mis à jour" : "Logo retiré");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="bg-card border-border" data-testid="logo-settings-card">
      <CardHeader>
        <CardTitle className="text-base font-semibold text-foreground flex items-center gap-2">
          <Image className="w-4 h-4 text-emerald-600 dark:text-emerald-400" /> Logo de l'entreprise
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">Affiché dans la barre latérale, la page de connexion et sur les reçus.</p>
        <div className={busy ? "opacity-60 pointer-events-none" : ""}>
          <ImageUpload value={logoPath} onChange={save} testid="logo-upload" />
        </div>
      </CardContent>
    </Card>
  );
}
